/**
 * View component for /nodes/:nodeId
 *
 * Displays a single node from the 'byId' map in the node reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as nodeActions from '../nodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import node components
import NodeLayout from '../components/NodeLayout.js.jsx';

// import node css modules
import nodeStyles from '../nodeModuleStyles.css';


class SingleNode extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(nodeActions.fetchSingleIfNeeded(match.params.nodeId));
  }

  render() {
    const { nodeStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual node object from the map
     */
    const selectedNode = nodeStore.selected.getItem();

    const isEmpty = (
      !selectedNode
      || !selectedNode._id
      || nodeStore.selected.didInvalidate
    );

    return (
      <NodeLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Node </h3>
              {isEmpty ?
                (nodeStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: nodeStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedNode.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Node </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the Node would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </NodeLayout>
    )
  }
}

SingleNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    nodeStore: store.node
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleNode)
);



// WEBPACK FOOTER //
// modules/node/views/SingleNode.js.jsx